<template>
<div class="other-nav" :ratio="0.2">
    <div class="other-nav-logo">
        <slot name="logo">
            <a :href="homePath">
                <img :src="logo">
            </a>
        </slot>
    </div>
    <div class="other-nav-left">
        <NavItem
            class="nav-left-item"
            v-for="menu in menus"
            :key="menu.label"
            :name="menu.label"
            @click.native="$emit('click', { module_nm: ['导航栏'], block_nm: menu.label})">
            <PopoverBlackContent
                v-bind="menu"
                :uploadFunc="file => uploadFuncWidthLoading(file, menu.upload, menu.href)"
                @expose="$emit('expose', { module_nm: ['导航栏'], block_nm: menu.label })"
                @uploadClick="params => $emit('click', { module_nm: ['导航栏'], block_nm: menu.label, ...params })"
                @click.native="e=>hanldeClick(e, { block_nm: menu.label, button_detail: { url: menu.href }})"/>
        </NavItem>
        <NavItem class="nav-left-item" name="设计模板"  @click.native="$emit('click', { module_nm: ['导航栏'], block_nm: '设计模板'})">
            <DesignTemplateBlack :uploadFunc="uploadFuncWidthLoading"  @expose="$emit('expose', { module_nm: ['导航栏'], block_nm: '设计模板'})" @click.native="e=>hanldeClick(e, { block_nm: '设计模板'})"/>
        </NavItem>
        <NavItem class="nav-left-item" name="更多功能">
            <ToolsBlack @expose="$emit('expose', { module_nm: ['导航栏'], block_nm: '更多功能'})" @click="item=>$emit('click', { module_nm: ['导航栏'], block_nm: '更多功能', button_nm: item.title, button_detail: {url: item.url}})"/>
        </NavItem>
        <slot />
    </div>
    <div class="other-nav-right">
        <User class="user" :session="session"/>
    </div>
</div>

</template>
<script>
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DesignTemplateBlack from '../components/design-template-black';
import PopoverBlackContent from '../components/popvoer-black-content';
import NavItem from '../components/nav-item';
import ToolsBlack from '../components/tools-black';
import User from '../components/user';
import { getMenus } from './config';
import { get } from 'lodash';
import { LOADING_HTML } from '../utils/constant';
import { Spin } from '@gaoding/gdui';
export default {
  name: 'v2-other-nav',
  components: {
    PopoverBlackContent,
    DesignTemplateBlack,
    NavItem,
    User,
    ToolsBlack
  },
  props: {
    // nav 类型， ps 或 uupoop
    type: {
      type: String,
      required: true
    },
    // 用户session
    session: {
      type: Object,
      required: true
    },
    // 主页地址，默认为 /
    homePath: {
      type: String,
      default: '/'
    },
    // 函数参数为files，应当在改函数中上传图片并返回一个值为图片url的promise
    uploadFunc: {
      type: Function // required: true

    }
  },
  computed: {
    logo() {
      var img;

      switch (this.type) {
        case 'ps':
          img = require('../assets/other/ps.svg');
          break;

        case 'uupoop':
          img = require('../assets/other/uupoop.svg');
          break;

        default:
          img = require('../assets/other/ps.svg');
          break;
      }

      return img;
    },

    menus() {
      return getMenus(this.type);
    }

  },
  methods: {
    uploadFuncWidthLoading(files, urlPrefix, link) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var newWindow, url;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (urlPrefix) {
                  _context.next = 3;
                  break;
                }

                window.open('_blank', link);
                return _context.abrupt("return");

              case 3:
                newWindow = window.open('about:blank', new Date().getTime());
                newWindow.document.write(LOADING_HTML);
                Spin.open({
                  tip: '图片上传中',
                  size: 'large'
                });
                _context.prev = 6;
                _context.next = 9;
                return _this.uploadFunc(files[0]);

              case 9:
                url = _context.sent;
                newWindow.location.href = urlPrefix + encodeURI(url);
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](6);
                console.log(_context.t0);

              case 16:
                _context.prev = 16;
                Spin.close();
                return _context.finish(16);

              case 19:
                return _context.abrupt("return", url);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 13, 16, 19]]);
      }))();
    },

    setIconStyle(isHover) {
      return {
        color: 'white',
        fill: 'white',
        opacity: isHover ? 1 : 0.9
      };
    },

    hanldeClick(e, params) {
      e.stopPropagation();
      var data = get(e, 'target.dataset');
      var detail = data.detail,
          name = data.name;

      if (!name) {
        return;
      }

      this.$emit('click', Object.assign({
        module_nm: ['导航栏'],
        button_detail: {
          url: detail
        },
        button_nm: name
      }, params));
    }

  }
};
</script>
<style scoped>
.other-nav {
  display: flex;
  height: 64px;
  background: #464748;
}
.other-nav /deep/ .nav-item {
  margin: 0;
}
.other-nav /deep/ .nav-item:hover {
  background: rgba(0, 0, 0, 0.12);
}
.other-nav /deep/ .nav-item-name {
  padding: 0 28px;
  line-height: 64px;
}
.other-nav /deep/ .nav-popover {
  background: transparent;
}
.other-nav-logo {
  margin-left: 12px;
  margin-right: 64px;
}
.other-nav-left {
  flex: 4;
}
.other-nav-right {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
.other-nav-right .user {
  margin-right: 24px;
}

</style>
